import { useState, useEffect, useId } from "react";
import resizeHandle from "/assets/textarea-resize-handle.svg";

export default function TextArea({
  label,
  placeholder,
  value,
  onChange,
  id,
  className = "",
  errors = [],
}) {
  const inputId = id || useId();

  if (typeof onChange !== "function")
    console.debug("A textarea doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  const handleChange = (event) => {
    if (typeof onChange === "function")
      onChange(event.target.value);

    setIsValid(true);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label htmlFor={inputId} className="lbl">{label}</label>
      )}
      <div className="inpt-txtarea-wrapper">
        <div className="inpt-txtarea-resize-handle"><img src={resizeHandle} /></div>
        <textarea
          id={inputId}
          className={`inpt-txtarea ${className}`}
          placeholder={placeholder}
          onChange={handleChange}
          defaultValue={value}
        />

        {!isValid && errors.map((error, index) => (
          <label key={index} className="lbl lbl--error">{error}</label>
        ))}
      </div>
    </div>
  );
}
